module.exports = __webpack_public_path__ + "img/mic-clinic-navi.abce495f.svg";